export enum ApplicationGroup {
  FA = 'FA',
  KDR = 'KDR',
  ON = 'ON',
  OP = 'OP',
  PPW = 'PPW',
  PS = 'PS',
  SR = 'SR',
  SW = 'SW',
  ZS = 'ZS',
}

export const APPLICATION_GROUP_LABELS: Record<ApplicationGroup, string> = {
  [ApplicationGroup.FA]: 'Fundusz Alimentacyjny',
  [ApplicationGroup.KDR]: 'Karta Dużej Rodziny',
  [ApplicationGroup.ON]: 'Obszar Osób Niepełnosprawnych',
  [ApplicationGroup.OP]: 'Opieka nad dzieckiem do lat 3',
  [ApplicationGroup.PPW]: 'Świadczenia wspierające',
  [ApplicationGroup.PS]: 'Pomoc Społeczna',
  [ApplicationGroup.SR]: 'Świadczenia Rodzinne',
  [ApplicationGroup.SW]: 'Świadczenia Wychowawcze',
  [ApplicationGroup.ZS]: 'Inne',
};

export function getApplicationGroupDropdownItems() {
  return Object.entries(APPLICATION_GROUP_LABELS).map(([key, label]) => ({
    label,
    value: key as ApplicationGroup,
  }));
}
